/**
 * IDI-639: Reopen and Edit's confirm, shared by the builder and the detail
 * page. A local Dialog (not useConfirm, which throws outside ConfirmProvider),
 * as ApplyConfirmDialog does.
 */
import React from 'react';
import { Button } from '../ui/Button';
import { Dialog, DialogHeader, DialogBody } from '../ui/Dialog';

// D3/D5: Sent, Rejected and Approved-not-added reopen; admins and admin sales only.
const REOPENABLE = ['sent', 'declined', 'accepted', 'approved'];
const REOPEN_ROLES = ['admin', 'admin_sales'];

export function canReopenCo(user, status) {
  if (!REOPENABLE.includes(status)) return false;
  return REOPEN_ROLES.includes(user?.role) || (user?.groups || []).some((g) => REOPEN_ROLES.includes(g));
}

export const REOPEN_SUCCESS = 'Change order reopened for editing';
export const REOPEN_FAILURE = "Couldn't reopen this change order. Try again.";

export default function ReopenConfirmDialog({ open, status, loading, onClose, onConfirm }) {
  if (!open) return null;
  const approved = status === 'accepted' || status === 'approved';
  return (
    <Dialog open onClose={onClose} size="sm">
      <DialogHeader onClose={onClose}>Reopen and edit this change order?</DialogHeader>
      <DialogBody>
        <div className="space-y-3 text-sm" data-testid="co-reopen-confirm" style={{ color: 'var(--color-text-secondary)' }}>
          <p>The customer&apos;s signing link will stop working, and the change order returns to Draft.</p>
          {approved && <p>This voids the customer&apos;s acceptance. It must be sent and accepted again before Add to Job.</p>}
          <div className="flex justify-end gap-3 pt-2">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button onClick={onConfirm} loading={loading}>Reopen and Edit</Button>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
}
